module.exports = __webpack_public_path__ + "img/contabilidade.1ffcd05e.jpg";